"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.freeStatusMap = exports.statusToNextPlanInfo = exports.statusToNextPlan = exports.statusToAccountInfoMap = exports.ADMIN_RECIPE_LIMIT = exports.SEASONED_SUBCRIPTION_RECIPE_LIMIT = exports.STANDARD_SUBCRIPTION_RECIPE_LIMIT = exports.CURRENT_STARTING_RECIPE_LIMIT = exports.FREE_RECIPE_LIMIT = exports.BOROS_RECIPE_LIMIT = exports.statusToPlanId = exports.UPGRADE_TO_SEASONED_COOK_OPERATION = exports.PADDLE_SEASONED_COOK_YEARLY_PLAN_ID = exports.PADDLE_SEASONED_COOK_MONTHLY_PLAN_ID = exports.PADDLE_HOME_COOK_LATEST_YEARLY_PLAN_ID = exports.PADDLE_HOME_COOK_LATEST_MONTHLY_PLAN_ID = exports.PADDLE_HOME_COOK_OG_YEARLY_PLAN_ID = exports.PADDLE_HOME_COOK_OG_PLAN_ID = exports.CURRENT_STARTING_STATUS = exports.CUSTOM_STATUS = exports.SEASONED_SUBSCRIPTION_EXPIRED_STATUS = exports.SEASONED_SUBSCRIPTION_CANCELLED_STATUS = exports.STANDARD_SUBSCRIPTION_EXPIRED_STATUS = exports.STANDARD_SUBSCRIPTION_CANCELLED_STATUS = exports.SEASONED_SUBSCRIPTION_STATUS = exports.STANDARD_SUBSCRIPTION_STATUS = exports.BETA_STATUS = exports.FREE_STATUS = exports.BOROS_STATUS = exports.ADMIN_STATUS = void 0;
exports.ADMIN_STATUS = "admin";
exports.BOROS_STATUS = "boros";
exports.FREE_STATUS = "free";
exports.BETA_STATUS = "beta";
exports.STANDARD_SUBSCRIPTION_STATUS = "standard-subscription";
exports.SEASONED_SUBSCRIPTION_STATUS = "seasoned-subscription";
exports.STANDARD_SUBSCRIPTION_CANCELLED_STATUS = "standard-subscription-cancelled";
exports.STANDARD_SUBSCRIPTION_EXPIRED_STATUS = "standard-subscription-expired";
exports.SEASONED_SUBSCRIPTION_CANCELLED_STATUS = "seasoned-subscription-cancelled";
exports.SEASONED_SUBSCRIPTION_EXPIRED_STATUS = "seasoned-subscription-expired";
exports.CUSTOM_STATUS = "custom";
exports.CURRENT_STARTING_STATUS = exports.BOROS_STATUS;
exports.PADDLE_HOME_COOK_OG_PLAN_ID = "571836";
exports.PADDLE_HOME_COOK_OG_YEARLY_PLAN_ID = "581100";
exports.PADDLE_HOME_COOK_LATEST_MONTHLY_PLAN_ID = "587330";
exports.PADDLE_HOME_COOK_LATEST_YEARLY_PLAN_ID = "587329";
exports.PADDLE_SEASONED_COOK_MONTHLY_PLAN_ID = "580984";
exports.PADDLE_SEASONED_COOK_YEARLY_PLAN_ID = "587328";
exports.UPGRADE_TO_SEASONED_COOK_OPERATION = "upgrade-to-seasoned-cook";
exports.statusToPlanId = (status, yearly = true) => {
    if (status === "seasoned-subscription" && yearly) {
        return exports.PADDLE_SEASONED_COOK_YEARLY_PLAN_ID;
    }
    else if (status === "seasoned-subscription") {
        return exports.PADDLE_SEASONED_COOK_MONTHLY_PLAN_ID;
    }
    else if (status === "standard-subscription" && yearly) {
        return exports.PADDLE_HOME_COOK_LATEST_YEARLY_PLAN_ID;
    }
    else if (status === "standard-subscription") {
        return exports.PADDLE_HOME_COOK_LATEST_MONTHLY_PLAN_ID;
    }
    return "";
};
exports.BOROS_RECIPE_LIMIT = 25;
exports.FREE_RECIPE_LIMIT = 50;
exports.CURRENT_STARTING_RECIPE_LIMIT = exports.BOROS_RECIPE_LIMIT;
exports.STANDARD_SUBCRIPTION_RECIPE_LIMIT = 1000;
exports.SEASONED_SUBCRIPTION_RECIPE_LIMIT = 5000;
exports.ADMIN_RECIPE_LIMIT = 10000;
const STARTING_STATUS_NAME = "Budding Cook";
exports.statusToAccountInfoMap = {
    [exports.BOROS_STATUS]: {
        key: exports.BOROS_STATUS,
        name: STARTING_STATUS_NAME,
        recipeLimit: exports.BOROS_RECIPE_LIMIT,
    },
    [exports.FREE_STATUS]: {
        key: exports.FREE_STATUS,
        name: STARTING_STATUS_NAME,
        recipeLimit: exports.FREE_RECIPE_LIMIT,
    },
    [exports.BETA_STATUS]: {
        key: exports.BETA_STATUS,
        name: "Home Cook",
        recipeLimit: exports.STANDARD_SUBCRIPTION_RECIPE_LIMIT,
    },
    [exports.STANDARD_SUBSCRIPTION_STATUS]: {
        key: exports.STANDARD_SUBSCRIPTION_STATUS,
        name: "Home Cook",
        recipeLimit: exports.STANDARD_SUBCRIPTION_RECIPE_LIMIT,
        monthlyCheckoutId: exports.PADDLE_HOME_COOK_LATEST_MONTHLY_PLAN_ID,
        yearlyCheckoutId: exports.PADDLE_HOME_COOK_LATEST_YEARLY_PLAN_ID,
        cost: 5,
    },
    [exports.SEASONED_SUBSCRIPTION_STATUS]: {
        key: exports.SEASONED_SUBSCRIPTION_STATUS,
        name: "Seasoned Cook",
        recipeLimit: exports.SEASONED_SUBCRIPTION_RECIPE_LIMIT,
        monthlyCheckoutId: exports.PADDLE_SEASONED_COOK_MONTHLY_PLAN_ID,
        yearlyCheckoutId: exports.PADDLE_SEASONED_COOK_YEARLY_PLAN_ID,
        cost: 10,
    },
    [exports.STANDARD_SUBSCRIPTION_CANCELLED_STATUS]: {
        key: exports.STANDARD_SUBSCRIPTION_CANCELLED_STATUS,
        name: "Home Cook",
        recipeLimit: exports.STANDARD_SUBCRIPTION_RECIPE_LIMIT,
    },
    [exports.SEASONED_SUBSCRIPTION_CANCELLED_STATUS]: {
        key: exports.SEASONED_SUBSCRIPTION_CANCELLED_STATUS,
        name: "Seasoned Cook",
        recipeLimit: exports.SEASONED_SUBCRIPTION_RECIPE_LIMIT,
    },
    [exports.STANDARD_SUBSCRIPTION_EXPIRED_STATUS]: {
        key: exports.STANDARD_SUBSCRIPTION_EXPIRED_STATUS,
        name: "Home Cook",
        recipeLimit: exports.FREE_RECIPE_LIMIT,
    },
    [exports.SEASONED_SUBSCRIPTION_EXPIRED_STATUS]: {
        key: exports.SEASONED_SUBSCRIPTION_EXPIRED_STATUS,
        name: "Seasoned Cook",
        recipeLimit: exports.FREE_RECIPE_LIMIT,
    },
    [exports.ADMIN_STATUS]: {
        key: exports.ADMIN_STATUS,
        name: "Admin",
        recipeLimit: exports.ADMIN_RECIPE_LIMIT,
    },
    [exports.CUSTOM_STATUS]: {
        key: exports.CUSTOM_STATUS,
        name: "Custom",
        recipeLimit: exports.SEASONED_SUBCRIPTION_RECIPE_LIMIT,
    },
};
exports.statusToNextPlan = {
    [exports.BOROS_STATUS]: exports.STANDARD_SUBSCRIPTION_STATUS,
    [exports.FREE_STATUS]: exports.STANDARD_SUBSCRIPTION_STATUS,
    [exports.STANDARD_SUBSCRIPTION_CANCELLED_STATUS]: exports.STANDARD_SUBSCRIPTION_STATUS,
    [exports.STANDARD_SUBSCRIPTION_EXPIRED_STATUS]: exports.STANDARD_SUBSCRIPTION_STATUS,
    [exports.SEASONED_SUBSCRIPTION_STATUS]: exports.CUSTOM_STATUS,
    [exports.BETA_STATUS]: exports.SEASONED_SUBSCRIPTION_STATUS,
    [exports.STANDARD_SUBSCRIPTION_STATUS]: exports.SEASONED_SUBSCRIPTION_STATUS,
    [exports.SEASONED_SUBSCRIPTION_CANCELLED_STATUS]: exports.SEASONED_SUBSCRIPTION_STATUS,
    [exports.SEASONED_SUBSCRIPTION_EXPIRED_STATUS]: exports.SEASONED_SUBSCRIPTION_STATUS,
    [exports.ADMIN_STATUS]: exports.CUSTOM_STATUS,
    [exports.CUSTOM_STATUS]: exports.CUSTOM_STATUS,
};
exports.statusToNextPlanInfo = {
    [exports.BOROS_STATUS]: exports.statusToAccountInfoMap[exports.statusToNextPlan[exports.BOROS_STATUS]],
    [exports.FREE_STATUS]: exports.statusToAccountInfoMap[exports.statusToNextPlan[exports.FREE_STATUS]],
    [exports.STANDARD_SUBSCRIPTION_CANCELLED_STATUS]: exports.statusToAccountInfoMap[exports.statusToNextPlan[exports.STANDARD_SUBSCRIPTION_CANCELLED_STATUS]],
    [exports.STANDARD_SUBSCRIPTION_EXPIRED_STATUS]: exports.statusToAccountInfoMap[exports.statusToNextPlan[exports.STANDARD_SUBSCRIPTION_EXPIRED_STATUS]],
    [exports.SEASONED_SUBSCRIPTION_STATUS]: exports.statusToAccountInfoMap[exports.statusToNextPlan[exports.SEASONED_SUBSCRIPTION_STATUS]],
    [exports.BETA_STATUS]: exports.statusToAccountInfoMap[exports.statusToNextPlan[exports.BETA_STATUS]],
    [exports.STANDARD_SUBSCRIPTION_STATUS]: exports.statusToAccountInfoMap[exports.statusToNextPlan[exports.STANDARD_SUBSCRIPTION_STATUS]],
    [exports.SEASONED_SUBSCRIPTION_CANCELLED_STATUS]: exports.statusToAccountInfoMap[exports.statusToNextPlan[exports.SEASONED_SUBSCRIPTION_CANCELLED_STATUS]],
    [exports.SEASONED_SUBSCRIPTION_EXPIRED_STATUS]: exports.statusToAccountInfoMap[exports.statusToNextPlan[exports.SEASONED_SUBSCRIPTION_EXPIRED_STATUS]],
    [exports.ADMIN_STATUS]: exports.statusToAccountInfoMap[exports.statusToNextPlan[exports.ADMIN_STATUS]],
    [exports.CUSTOM_STATUS]: exports.statusToAccountInfoMap[exports.statusToNextPlan[exports.CUSTOM_STATUS]],
};
exports.freeStatusMap = {
    [exports.BOROS_STATUS]: true,
    [exports.FREE_STATUS]: true,
    [exports.BETA_STATUS]: true,
};
//# sourceMappingURL=account.js.map